var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-group"},[_c('input',{attrs:{"type":"checkbox","id":_vm.keyi},on:{"change":function($event){return _vm.onChange($event)}}}),_c('label',{attrs:{"for":_vm.keyi}},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }